import React, { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { useTranslation } from "react-i18next";
import "../FitAgGrid/FitAgGridContainer.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-enterprise";
import '../Header/Header.css';


function MediumRiskScore(props) {
  // Column definitions
  const headerClass = 'center-header';
  const { i18n } = useTranslation();
  let dir = "ltr";
  if (i18n.language === "ar") {
    dir = "rtl";
  }

  let enableRtl = false;
  if (i18n.language === "ar") {
    enableRtl = true;
  }

  let agGridClass = "ag-theme-alpine";
  if (props.isDarkMode) {
    agGridClass = "ag-theme-alpine-dark";
  }else {
    if (localStorage.getItem('theme') == 'dark') {
      agGridClass = "ag-theme-alpine-dark"
    }
  }

  const [columnDefs] = useState([
    {
      field: 'market',
      headerName: 'Market',
      cellRenderer: 'marketCellRenderer', // Use the custom renderer for the market column
      headerClass: headerClass,
    },
    { field: 'buySell', headerName: 'BUY/SELL', cellRenderer: 'buySellRenderer', headerClass: headerClass },
    { field: 'invested', headerName: 'INVESTED', headerClass: headerClass, },
    { field: 'pl', headerName: 'P/L(%)', cellRenderer: 'plRenderer', headerClass: headerClass, },
    { field: 'value', headerName: 'VALUE', headerClass: headerClass, },
    { field: 'sell', headerName: 'SELL', cellRenderer: 'actionCellRenderer', headerClass: headerClass, },
    { field: 'buy', headerName: 'BUY', cellRenderer: 'actionCellRenderer', headerClass: headerClass, }
  ]);

  // Sample row data
  const [rowData] = useState([
    {
      market: 'NASDAQ',
      subValue: 'NASDAQ Stock Market',
      buySell: 'Buying',
      invested: '1.18%',
      pl: '1.53%',
      value: '4.93%',
      sell: 'Sell 84.3',
      buy: 'Buy 110.8',
    },
    {
      market: 'NASDAQ',
      subValue: 'NASDAQ Stock Market',
      buySell: 'Selling',
      invested: '4.34%',
      pl: '4.2%',
      value: '9.62%',
      sell: 'Sell 70.11',
      buy: 'Buy 127.38',
    },
    {
      market: 'DIFX',
      subValue: 'Dubai Financial Market',
      buySell: 'Selling',
      invested: '6.32%',
      pl: '1.73%',
      value: '9.75%',
      sell: 'Sell 91.5',
      buy: 'Buy 119.52',
    },
    {
      market: 'DIFX',
      subValue: 'Dubai Financial Market',
      buySell: 'Buying',
      invested: '1.69%',
      pl: '3.1%',
      value: '4.23%',
      sell: 'Sell 145.15',
      buy: 'Buy 106.38',
    },
    {
      market: 'NYSE',
      subValue: 'New York Stock Exchange',
      buySell: 'Selling',
      invested: '4.5%',
      pl: '3.42%',
      value: '7.77%',
      sell: 'Sell 183.0',
      buy: 'Buy 234.93',
    },
    {
      market: 'LSE',
      subValue: 'London Stock Exchange',
      buySell: 'Selling',
      invested: '1.51%',
      pl: '3.7%',
      value: '3.68%',
      sell: 'Sell 20.7',
      buy: 'Buy 24.97',
    },
    {
      market: 'NASDAQ',
      subValue: 'NASDAQ Stock Market',
      buySell: 'Buying',
      invested: '2.24%',
      pl: '9.84%',
      value: '1.25%',
      sell: 'Sell 113.47',
      buy: 'Buy 115.98',
    },
    {
      market: 'TADAWUL',
      subValue: 'Saudi Stock Exchange',
      buySell: 'Selling',
      invested: '5.31%',
      pl: '3.32%',
      value: '7.73%',
      sell: 'Sell 132.66',
      buy: 'Buy 171.97',
    },
    {
      market: 'NYSE',
      subValue: 'New York Stock Exchange',
      buySell: 'Selling',
      invested: '2.72%',
      pl: '3.98%',
      value: '5.34%',
      sell: 'Sell 148.03',
      buy: 'Buy 203.96',
    },
    {
      market: 'DIFX',
      subValue: 'Dubai Financial Market',
      buySell: 'Buying',
      invested: '6.88%',
      pl: '9.74%',
      value: '2.91%',
      sell: 'Sell 51.08',
      buy: 'Buy 144.02',
    },
    {
      market: 'ADX',
      subValue: 'Abu Dhabi Securities Exchange',
      buySell: 'Buying',
      invested: '4.21%',
      pl: '1.21%',
      value: '6.21%',
      sell: 'Sell 27.15',
      buy: 'Buy 220.15'
    },
    {
      market: 'ADX',
      subValue: 'Abu Dhabi Securities Exchange',
      buySell: 'Buying',
      invested: '4.21%',
      pl: '1.21%',
      value: '6.21%',
      sell: 'Sell 27.15',
      buy: 'Buy 220.15'
    },
    {
      market: 'NASDAQ',
      subValue: 'NASDAQ Stock Market',
      buySell: 'Selling',
      invested: '2.68%',
      pl: '2.39%',
      value: '2.06%',
      sell: 'Sell 245.15',
      buy: 'Buy 74.16',
    },
    {
      market: 'DIFX',
      subValue: 'Dubai Financial Market',
      buySell: 'Buying',
      invested: '0.63%',
      pl: '4.2%',
      value: '4.44%',
      sell: 'Sell 206.91',
      buy: 'Buy 103.55',
    },
    {
      market: 'NASDAQ',
      subValue: 'NASDAQ Stock Market',
      buySell: 'Selling',
      invested: '3.69%',
      pl: '2.23%',
      value: '4.13%',
      sell: 'Sell 63.82',
      buy: 'Buy 86.91',
    },
    {
      market: 'NYSE',
      subValue: 'New York Stock Exchange',
      buySell: 'Buying',
      invested: '3.7%',
      pl: '10.0%',
      value: '4.65%',
      sell: 'Sell 183.76',
      buy: 'Buy 80.14',
    },
    {
      market: 'TADAWUL',
      subValue: 'Saudi Stock Exchange',
      buySell: 'Buying',
      invested: '1.77%',
      pl: '4.65%',
      value: '9.15%',
      sell: 'Sell 103.61',
      buy: 'Buy 60.32',
    },
    {
      market: 'LSE',
      subValue: 'London Stock Exchange',
      buySell: 'Selling',
      invested: '9.85%',
      pl: '8.56%',
      value: '2.29%',
      sell: 'Sell 62.78',
      buy: 'Buy 141.91',
    },
    {
      market: 'NYSE',
      subValue: 'New York Stock Exchange',
      buySell: 'Selling',
      invested: '7.22%',
      pl: '8.71%',
      value: '7.88%',
      sell: 'Sell 66.38',
      buy: 'Buy 81.33',
    },
    {
      market: 'TADAWUL',
      subValue: 'Saudi Stock Exchange',
      buySell: 'Buying',
      invested: '1.1%',
      pl: '2.27%',
      value: '7.91%',
      sell: 'Sell 92.53',
      buy: 'Buy 87.13',
    },
    {
      market: 'NYSE',
      subValue: 'New York Stock Exchange',
      buySell: 'Selling',
      invested: '2.24%',
      pl: '2.9%',
      value: '0.75%',
      sell: 'Sell 183.95',
      buy: 'Buy 215.8',
    },
    {
      market: 'NASDAQ',
      subValue: 'NASDAQ Stock Market',
      buySell: 'Buying',
      invested: '4.38%',
      pl: '5.12%',
      value: '6.93%',
      sell: 'Sell 84.33',
      buy: 'Buy 107.43',
    },
    {
      market: 'DIFX',
      subValue: 'Dubai Financial Market',
      buySell: 'Buying',
      invested: '9.9%',
      pl: '2.18%',
      value: '5.89%',
      sell: 'Sell 138.13',
      buy: 'Buy 158.89',
    },
    {
      market: 'DIFX',
      subValue: 'Dubai Financial Market',
      buySell: 'Selling',
      invested: '6.88%',
      pl: '9.74%',
      value: '2.91%',
      sell: 'Sell 51.08',
      buy: 'Buy 144.02',
    },
    {
      market: 'TADAWUL',
      subValue: 'Saudi Stock Exchange',
      buySell: 'Buying',
      invested: '3.21%',
      pl: '7.54%',
      value: '8.33%',
      sell: 'Sell 125.67',
      buy: 'Buy 89.45',
    },
    {
      market: 'NYSE',
      subValue: 'New York Stock Exchange',
      buySell: 'Selling',
      invested: '5.63%',
      pl: '2.45%',
      value: '7.12%',
      sell: 'Sell 195.32',
      buy: 'Buy 112.67',
    },
    {
      market: 'DIFX',
      subValue: 'Dubai Financial Market',
      buySell: 'Buying',
      invested: '4.87%',
      pl: '3.65%',
      value: '6.01%',
      sell: 'Sell 142.58',
      buy: 'Buy 131.29',
    },
    {
      market: 'NASDAQ',
      subValue: 'NASDAQ Stock Market',
      buySell: 'Buying',
      invested: '2.34%',
      pl: '8.72%',
      value: '4.19%',
      sell: 'Sell 153.47',
      buy: 'Buy 95.11',
    },
    {
      market: 'LSE',
      subValue: 'London Stock Exchange',
      buySell: 'Selling',
      invested: '1.89%',
      pl: '6.23%',
      value: '3.78%',
      sell: 'Sell 44.19',
      buy: 'Buy 150.22',
    },
    {
      market: 'TADAWUL',
      subValue: 'Saudi Stock Exchange',
      buySell: 'Selling',
      invested: '7.90%',
      pl: '1.33%',
      value: '5.27%',
      sell: 'Sell 73.44',
      buy: 'Buy 194.58',
    },
    {
      market: 'NYSE',
      subValue: 'New York Stock Exchange',
      buySell: 'Buying',
      invested: '6.56%',
      pl: '4.97%',
      value: '2.31%',
      sell: 'Sell 189.27',
      buy: 'Buy 103.12',
    },
    {
      market: 'NASDAQ',
      subValue: 'NASDAQ Stock Market',
      buySell: 'Selling',
      invested: '8.41%',
      pl: '5.89%',
      value: '6.74%',
      sell: 'Sell 121.48',
      buy: 'Buy 134.55',
    },
    {
      market: 'DIFX',
      subValue: 'Dubai Financial Market',
      buySell: 'Selling',
      invested: '3.48%',
      pl: '7.62%',
      value: '4.86%',
      sell: 'Sell 88.35',
      buy: 'Buy 143.97',
    },
    {
      market: 'LSE',
      subValue: 'London Stock Exchange',
      buySell: 'Buying',
      invested: '5.12%',
      pl: '2.04%',
      value: '8.97%',
      sell: 'Sell 57.09',
      buy: 'Buy 116.84',
    }

    // ... more row data
  ]);

  // Custom cell renderer for the Market column
  const MarketCellRenderer = ({ value, data }) => {
    const iconStyle = {
      height: '20px',
      width: '20px',
      borderRadius: '50%',
      backgroundColor: '#ddd', // Placeholder for the icon background
      display: 'inline-block',
      marginRight: '5px',
      backgroundImage: '', // Uncomment and replace with your icon URL
      backgroundSize: 'cover',
    };

    const mainValueStyle = {
      fontWeight: 'bold',
    };

    const subValueStyle = {
      fontSize: '0.85em',
      color: 'grey',
    };

    return (

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={iconStyle} />{/* Icon placeholder */}
        <div>
          <div style={mainValueStyle}>{value}</div>
          <div style={subValueStyle}>{data.subValue}</div>
        </div>
      </div>
    );
  };

  // Custom cell renderer for the BUY/SELL column
  const BuySellRenderer = ({ value }) => {
    const buySellStyle = {
      color: value === 'Buying' ? '#0c9801' : '#ee0000',
      fontWeight: 'bold',
      textAlign: 'center',
      border: value === 'Buying' ? '1px solid #0c9801' : '1px solid #ee0000',
      padding: "5px",
      marginTop: "2px",
    };
    return <span style={buySellStyle}>{value}</span>;
  };

  const PLRenderer = (params) => {
    const plStyle = {
      color: params.data.buySell === 'Buying' ? '#0c9801' : '#ee0000',
    };
    return <span style={plStyle}>{params.value}</span>;
  };

  // Custom cell renderer for the action buttons
  const ActionCellRenderer = ({ value }) => {
    const [action, price] = value.split(' ');
    const actionStyle = {
      color: 'white',
      backgroundColor: action === 'Buy' ? '#0c9801' : '#ee0000',
      padding: '5px 10px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      marginRight: '4px'
    };
    return (
      <button style={actionStyle}>
        {action} <div style={{ fontSize: '20px' }}>{price}</div>
      </button>
    );
  };

  // Framework components for custom cell renderers
  const frameworkComponents = {
    marketCellRenderer: MarketCellRenderer,
    buySellRenderer: BuySellRenderer,
    actionCellRenderer: ActionCellRenderer,
    plRenderer: PLRenderer,
  };

  // Default column definitions
  const defaultColDef = {
    flex: 1,
    minWidth: 120,
    sortable: true,
    resizable: true,
    cellStyle: { textAlign: 'center', lineHeight: '2.5' },
    headerClass: headerClass,
  };


  const rowHeight = 50; // Adjust this value as needed


  return (
    <div
      dir={dir}
      style={
        props.isDarkMode
          ? {
            background: "black",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }
          : {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }
      }
    >
      <div
        className={props.isDarkMode ? agGridClass : "ag-theme-alpine"}
        style={{
          height: "93%",
          width: "97%"
        }}
        dir={dir}
      >
        <AgGridReact
          columnDefs={columnDefs}
          enableRtl={enableRtl}
          rowData={rowData}
          frameworkComponents={frameworkComponents}
          defaultColDef={defaultColDef}
          rowHeight={rowHeight}
          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center" id="ag-loading_data">' +
            i18n.t("ag-overlay-loading-center") +
            "</span>"
          }
          overlayNoRowsTemplate={
            '<span className="ag-overlay-NoRows-center" id="ag-NoRows">' +
            i18n.t("ag-overlay-noRow-center") +
            "</span>"
          }
        />
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 20px',
          borderTop: '1px solid #e0e0e0',
        }}>
          <div>Balance</div>
          <div style={{ display: "flex" }}>
            <div style={{ fontSize: "20px", fontWeight: "bold", marginRight: "10px" }}>1939%</div>
            <div style={{ fontSize: "12px" }}>Balance</div></div>
        </div>
      </div>
    </div>
  );
}

export default MediumRiskScore;
